import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ls-tooltip]'
})
export class TooltipDirective {
  @HostBinding('class.tooltip')
  public tooltipClass = true;
}
